import axiosClient from "../axiosClient";
import { Facture } from "../interfaces/facture.interface";

export const findAllFactures = async () => {
  const { data } = await axiosClient.get<Facture[]>("/factures/mes-factures");
  return data;
};

export const findOneFacture = async (id: string | null) => {
  if (id === null) throw "ID manquant";
  const { data } = await axiosClient.get<Facture>(`/factures/${id}`);
  return data;
};
